<app-page-heading [key]="'local-loads.import.page-title'"></app-page-heading>


<section class="container-fluid">
    <div *ngIf="showCarrierSelection" class="m-b-md">
        <label for="select-carrier">Select a carrier</label>
        <select id="select-carrier" class="form-control" [(ngModel)]="selectedCarrier" (change)="changeCarrier()">
            <option *ngFor="let c of carriers" [ngValue]="c">{{c.name}}</option>
        </select>
    </div>

    <div class="m-b-md" *ngIf="!showCarrierSelection || !!selectedCarrier">
        <label for="select-source" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.source.title'}]"></label>
        <select id="select-source" class="form-control" [(ngModel)]="selectedSource" (change)="changeSource()">
            <option *ngIf="showBlujaySource" [ngValue]="TmsType.BLUJAY" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.tms-type.blujay'}]"></option>
            <option *ngIf="showBlueyonderSource" [ngValue]="TmsType.BLUEYONDER" [i18n]="[{target: 'innerHTML', key: 'user-dashboard.tms-type.blueyonder'}]"></option>
            <option [ngValue]="TmsType.LOCAL">File</option>
        </select>
    </div>

    <div *ngIf="showImportArea && selectedSource === TmsType.LOCAL">
        <button class="btn btn-default m-b-md" (click)="downloadCsvTemplate()">
            <i class="fa fa-download"></i>
            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.buttons.download-template'}]"></span>
        </button>
        <div class="file-drop-container">
            <app-file-drop [(files)]="files" [disabled]="done" (onChange)="changeFile()"></app-file-drop>

            <button class="btn btn-primary btn-xl m-l-sm btn-import" (click)="importLoads()" [disabled]="isFileImportInvalid()">
                <i class="fa fa-upload"></i>
                <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.buttons.import'}]"></span>
            </button>
        </div>
    </div>
    <div class="tms-synchronization-container" *ngIf="showImportArea && selectedSourceIsTms">
        <button class="btn btn-primary btn-lg btn-import"
                *ngIf="!tmsSyncIsInProgress"
                [disabled]="(showCarrierSelection && !selectedCarrier) || doing"
                (click)="synchronizeTmsLoads()">
            <i class="fa fa-refresh"></i>
            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.tms.buttons.import'}]"></span>
        </button>
        <button class="btn btn-primary btn-lg btn-import"
                *ngIf="tmsSyncIsInProgress"
                [disabled]="doing"
                (click)="loadCarrierLastImport()">
            <i class="fa fa-refresh"></i>
            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.tms.buttons.status-refresh'}]"></span>
        </button>
    </div>

    <div class="import-result alert alert-success"
         *ngIf="!doing && done && succeed && !partiallySucceed">
        <i class="fa fa-smile"></i>

        <ng-container *ngIf="selectedSource === TmsType.LOCAL">
            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.succeed'}]"></span>

            <button class="btn btn-success" (click)="reset()">
                <i class="fa fa-undo"></i>
                <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.buttons.import-again'}]"></span>
            </button>
        </ng-container>

        <ng-container *ngIf="selectedSourceIsTms">
            <span *ngIf="tmsResult && !tmsResult.pickMinDate"
                  [i18n]="[{target: 'innerHTML' ,key: 'local-loads.import.tms.succeed',
                  params: { date: lastImportDate | fullDate, pickMaxDate: tmsResult.pickMaxDate | fullDate: false }}]">
            </span>
            <span *ngIf="tmsResult && tmsResult.pickMinDate"
                  [i18n]="[{target: 'innerHTML' ,key: 'local-loads.import.tms.succeed-with-planned-start-date',
                  params: { date: lastImportDate | fullDate, pickMaxDate: tmsResult.pickMaxDate | fullDate: false, pickMinDate: tmsResult.pickMinDate | fullDate: false}}]">
            </span>
            <span *ngIf="!tmsResult"
                  [i18n]="[{target: 'innerHTML' ,key: 'local-loads.import.tms.succeed-alt',
                  params: { date: lastImportDate | fullDate }}]">
            </span>
        </ng-container>
    </div>

    <div class="import-result alert alert-warning" *ngIf="!doing && done && partiallySucceed && selectedSourceIsTms">
        <i class="fa fa-meh"></i>
        <span *ngIf="tmsResult && !tmsResult.pickMinDate" [i18n]="[{target: 'innerHTML' ,key: 'local-loads.import.tms.partially-succeed',
              params: { date: lastImportDate | fullDate, pickMaxDate: tmsResult.pickMaxDate | fullDate: false}}]"></span>
        <span *ngIf="tmsResult && tmsResult.pickMinDate" [i18n]="[{target: 'innerHTML' ,key: 'local-loads.import.tms.partially-succeed-with-planned-start-date',
              params: { date: lastImportDate | fullDate, pickMaxDate: tmsResult.pickMaxDate | fullDate: false, pickMinDate: tmsResult.pickMinDate | fullDate: false}}]"></span>
    </div>

    <div class="import-result alert alert-danger" *ngIf="!doing && done && !succeed && !tmsSyncIsInProgress">
        <i class="fa fa-frown"></i>

        <ng-container *ngIf="selectedSource === TmsType.LOCAL">
            <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.failed.default'}]"></span>

            <button class="btn btn-danger" (click)="reset()">
                <i class="fa fa-undo"></i>
                <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.buttons.import-again'}]"></span>
            </button>
        </ng-container>

        <ng-container *ngIf="selectedSourceIsTms">
            <div>
                <div [i18n]="[{target: 'innerHTML', key: 'local-loads.import.tms.failed.default', params: { date: lastImportDate | fullDate }}]"></div>
                <div [i18n]="'local-loads.import.tms.timeout.error'"></div>
                <div [i18n]="'local-loads.import.tms.timeout.reason'"></div>
                <div [i18n]="'local-loads.import.tms.timeout.solution'"></div>
            </div>
        </ng-container>
    </div>

    <ng-container *ngIf="tmsSyncIsInProgress">
        {{currentTmsSyncStatus}}
        <div class="progress">
            <div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="1" aria-valuemin="1" aria-valuemax="4" [style.width]="tmsSyncProgressPercent"></div>
        </div>
    </ng-container>

    <div class="import-result alert alert-danger" *ngIf="done && !succeed && globalErrorMessage">
        {{ globalErrorMessage }}
    </div>

    <div class="import-result alert alert-warning" *ngIf="files.length >= 1 && invalidFileType">
        <i class="fa fa-exclamation-triangle"></i>
        {{ globalErrorMessage }}
    </div>

    <div class="import-result alert alert-warning" *ngIf="done && fileResult && fileResult.unexpectedColumns.length > 0">
        <i class="fa fa-exclamation-triangle"></i>


        <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.failed.unexpected-columns'}]"></span>
        <label class="label label-warning" *ngFor="let c of fileResult.unexpectedColumns">{{c.name}}</label>
        <span [i18n]="[{target: 'innerHTML', key: 'local-loads.import.file.failed.separator-notice'}]"></span><label class="label label-warning" >;</label>
    </div>

    <div *ngIf="done && fileResult && fileResult.rows.length > 0">
        <div class="ibox" [ngClass]="{ 'ibox-success': succeed, 'ibox-danger': !succeed }">
            <div class="ibox-content no-padding">
                <div class="list-group">
                    <div class="list-group-item" *ngFor="let row of fileResult.rows">
                        <app-row-result [row]="row" [columns]="fileResult.columns"></app-row-result>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="done && tmsResult">
        <app-tms-import-result [result]="tmsResult"></app-tms-import-result>
    </div>
</section>
